import { GridCustomCellProps } from '@progress/kendo-react-grid';
import dayjs from 'dayjs';
import { FleetMessage } from '.';
import { memo } from 'react';

const CreatedCell = (props: GridCustomCellProps) => {
  if (!props.field || props.rowType !== 'data') return null;

  const data = props.dataItem as FleetMessage;

  return (
      <td {...props.tdProps}>
          {data.CreatedDateTime ? dayjs.utc(data.CreatedDateTime).tz("America/New_York").format('MM/DD/YYYY HH:mm') : ''}
      </td>
  );
}

export default memo(CreatedCell, (prev, next) => prev.dataItem.Hash === next.dataItem.Hash);
